import { render, staticRenderFns } from "./BaseBullet.vue?vue&type=template&id=2d1be2e6&scoped=true&"
import script from "./BaseBullet.vue?vue&type=script&lang=js&"
export * from "./BaseBullet.vue?vue&type=script&lang=js&"
import style0 from "./BaseBullet.vue?vue&type=style&index=0&id=2d1be2e6&lang=scss&scoped=true&"
import style1 from "./BaseBullet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1be2e6",
  null
  
)

export default component.exports